import React, { useGlobal } from 'reactn'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import Empty from 'ui/pages/med/Empty'
import type { OAuthTarget } from 'types/med'
import { useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { originUrl } from 'config/url'
import information from 'config/information'

const sessionStoragePrefix = 'yq_'
const windowNamePrefix = 'connect_'

export type OAuthResponse = {
  code?: string
  error?: {
    type: string
    description?: string
  }
}

// TODO: Promiseを返すようにする
export const connectOAuth: (type: OAuthTarget, client_id: string) => boolean = (
  type,
  client_id
) => {
  const uuid = uuidv4()
  sessionStorage.setItem(
    `${sessionStoragePrefix}${windowNamePrefix}${type}`,
    uuid
  )
  let params: {
    client_id: string
    redirect_uri: string
    state: string
    response_type: 'code'
    scope?: string
  } = {
    client_id,
    redirect_uri: `${originUrl}/${type}/authentication`,
    state: uuid,
    response_type: 'code',
  }
  let targetUrl: string = ''
  switch (type) {
    case 'stripe':
      params.scope = 'read_write'
      targetUrl = 'https://connect.stripe.com/oauth/authorize'
      break
    case 'teams':
      params.scope = 'offline_access user.read OnlineMeetings.ReadWrite'
      targetUrl =
        'https://login.microsoftonline.com/common/oauth2/v2.0/authorize'
      break
    case 'zoom':
      targetUrl = 'https://zoom.us/oauth/authorize'
  }
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([name, value]) => {
    searchParams.append(name, value ? String(value) : '')
  })
  const windowName: string = `${windowNamePrefix}${type}` // NOTE: OAuthコンポーネントのwindowNameに対応する
  const childWindow = window.open(
    `${targetUrl}?${searchParams.toString()}`,
    windowName,
    undefined
  )
  return !!childWindow
}

const OAuth: React.FC = () => {
  const [, setError] = useGlobal('error')
  const location = useLocation()
  const query = queryString.parse(location.search)

  const windowNames = ['connect_stripe', 'connect_teams', 'connect_zoom']
  const windowName = window.name
  const isValidWindowName = windowNames.includes(windowName)
  const token = sessionStorage.getItem(`${sessionStoragePrefix}${windowName}`)
  const isValidToken = query.state === token

  useEffect(() => {
    if (isValidWindowName && isValidToken) {
      const response: OAuthResponse = {
        code: query?.code as string,
        error: query?.error
          ? {
              type: query.error as string,
              description: query?.error_description as string | undefined,
            }
          : undefined,
      }

      window?.opener?.postMessage(
        {
          [windowName]: response,
        },
        originUrl
      )
      window?.close?.()
    } else {
      setError('forbidden')
    }
    // NOTE: ZoomAppMarketPlaceから直接きてしまったときはマニュアルぺージに遷移
    if (!windowName && location.pathname === '/zoom/authentication') {
      window.location.assign(information.med.manual)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <Empty />
}

export default OAuth
